import { assets, type ImageAsset } from '@/assets';

/** A friendly guide character who coaches the child; never a foe. */
export interface Helper {
  id: string;
  portraits: {
    /** Pointing up with a clipboard: coaching and feedback. */
    clipboard: ImageAsset;
    /** Pointing up with a tablet: explaining and results. */
    tablet: ImageAsset;
  };
}

export const labBunny: Helper = {
  id: 'lab-bunny',
  portraits: {
    clipboard: assets.characters.helperBunny.clipboard,
    tablet: assets.characters.helperBunny.tablet,
  },
};
